<style>
  .fix-static-bug {
    width: 100% !important;
    position: static !important;
  }

  .grey {
    color: #383838;
  }

  .padding30 {
    padding: 16px;
  }

  .link {
    float: right;
    margin-right: 20px;
    position: relative;
    top: 15px;
  }

  .infotext {
    padding-left: 15px;
    font-size: 80%;
    margin-top: -15px;
    padding-bottom: 15px;
  }

  .summary-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .admin-view-button {
    margin-left: 15px;
  }

  .person {
    float: right;
  }

  .infoicon {
    font-size: 16px;
    position: relative;
    top: 5px;
  }

  .save-button-info {
    display: inline-block;
    line-height: 1;
    vertical-align: middle;
  }

  .save-button-info .infoicon {
    top: 3px;
    vertical-align: middle;
  }

  .light-grey {
    color: lightgrey;
  }

  tr:nth-child(even) {
    background-color: #f2f2f2; /* Light grey color */
  }

  .card-field-row {
    margin-left: 0;
    margin-right: 0;
  }

  .card-field-row .mat-form-field {
    margin-bottom: 8px;
  }

  .tight-columns {
    margin-left: -7.5px;
    margin-right: -7.5px;
  }

  .tight-columns > [class^="col-"],
  .tight-columns > [class*=" col-"] {
    padding-left: 7.5px;
    padding-right: 7.5px;
  }

  .fix-static-bug mat-card {
    display: flow-root;
    /*padding: 16px;*/
  }

  .card-stack {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .card-stack mat-card {
    margin: 0;
  }

  .card-gap-row > [class^="col-"],
  .card-gap-row > [class*=" col-"] {
    margin-bottom: 16px;
  }

  .fix-static-bug ::ng-deep .no-subscript .mat-mdc-form-field-subscript-wrapper {
    display: none;
    height: 0;
    margin: 0;
    padding: 0;
  }

  .tabbable-static-value {
    width: 100%;
    border: 0;
    background: transparent;
    padding: 0;
    color: inherit;
  }

  .tabbable-static-value:focus {
    outline: 1px solid #808080;
    outline-offset: 2px;
  }

  .tabbable-static-value.bold-value {
    font-weight: 700;
  }

  textarea.tabbable-static-value {
    resize: none;
    overflow: hidden;
    white-space: pre-wrap;
  }

</style>

<div class="fix-static-bug">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <h3 class="main-heading sam-page-heading">In- och utbetalning</h3>
        <button *ngIf="openedByModal" mat-icon-button style="position: absolute; top: 0; right: 0;" (click)="onClose()" aria-label="Stäng" matTooltip="Stäng">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div *ngIf="isLoading" class="loading-overlay">
      <mat-spinner diameter="50"></mat-spinner>
    </div>


    <!--Calculate partial total amount / gross salary-->
    <section *ngIf="calculationError" aria-label="Beräkningen kunde inte slutföras">
      <p role="alert" class="mat-error">{{ calculationError }}</p>
      <mat-form-field>
        <mat-label>Datum för ny beräkning</mat-label>
        <input matInput [matDatepicker]="retryPayoutDate" [(ngModel)]="invoice.PayoutDate" (dateChange)="onPayoutDateChanged($event.value)">
        <mat-datepicker-toggle matSuffix [for]="retryPayoutDate"></mat-datepicker-toggle>
        <mat-datepicker #retryPayoutDate></mat-datepicker>
      </mat-form-field>
      <button mat-stroked-button type="button" (click)="onPayoutDateChanged(invoice.PayoutDate)">Försök igen</button>
    </section>
    <div *ngIf="isViewReady && invoice" class="row align-items-start tight-columns" style="background-color: #f3f3f3; padding: 20px 10px;">
      <div class="col-12 summary-header">
        <span>Beräkning av delsumma för bruttolön (inkl nettoersättningar)</span>
        <button mat-flat-button color="accent" class="admin-view-button" (click)="openInvoiceAdminDialog()" [disabled]="!invoice">
          Öppna admin-vy för fakturan
        </button>
      </div>
      <div *ngIf="invoice.SalaryShares != null && invoice.SalaryShares.length > 0" class="col-12" style="margin-bottom: 10px;">
        <b style="color: red;">Det finns en lönedelning på denna faktura</b><br />
      </div>
      <div *ngIf="userHasWageGarnishment" class="col-12" style="margin-bottom: 10px;">
        <b style="color: red;">Det finns en löneutmätning på medlemmen</b><br />
        <!--<button mat-flat-button color="accent" (click)="recalculateGarnishment()" [disabled]="isLoading" style="float:right; display: block;">Ladda om faktura</button>-->
      </div>
      <div *ngIf="invoice.SubInvoice && invoice.ApprovedForExpress" class="col-12" style="margin-bottom: 10px;">
        <b style="color: green;">Moderfakturan är godkänd för expressutbetalning</b><br />
      </div>
      <div *ngIf="!invoice.SubInvoice && !invoice.ParentInvoice && invoice.ExpressPayOut && invoice.ApprovedForExpress" class="col-12" style="margin-bottom: 10px;">
        <b style="color: green;">Express begärd och fakturan godkänd</b><br />
      </div>
      <div *ngIf="!invoice.SubInvoice && !invoice.ParentInvoice && !invoice.ApprovedForExpress && invoice.ExpressPayOut" class="col-12" style="margin-bottom: 10px;">
        <b style="color: red;">Express begärd men ej godkänd</b><br />
      </div>
      <div *ngIf="!invoice.SubInvoice && !invoice.ParentInvoice && invoice.ApprovedForExpress && !invoice.ExpressPayOut" class="col-12" style="margin-bottom: 10px;">
        <b style="color: red;">Express ej, men fakturan godkänd</b><br />
      </div>
      <div *ngIf="invoice.HasUnhandledDeductions" class="col-12" style="margin-bottom: 10px;">
        <b style="color: red;">Det finns ohanterade avdrag</b><br />
      </div>
      <div *ngIf="invoice.HasUnhandledAllowances" class="col-12" style="margin-bottom: 10px;">
        <b style="color: red;">Det finns ohanterade reseersättningar</b><br />
      </div>
      <div *ngIf="invoice?.UserSettings?.TaxAdjustments.length != 0 && invoice?.UserSettings?.TaxAdjustments.length > 0" class="col-12" style="margin-bottom: 10px;">
        <b *ngIf="!hasUnhandledTaxAdjustments" style="color: green;">Det finns en skattejämkning/skatteändring på medlemmen</b><br />
        <b *ngIf="hasUnhandledTaxAdjustments" style="color: red;">Det finns en <strong><u>ohanterad</u></strong> skattejämkning/skatteändring på medlemmen.</b>   <a href="#/users/{{invoice?.UserSettings?.Id}}" target="_blank"> Medlemmens inställningar </a><br />
      </div>
      <div *ngIf="taxAdjustmentThresholdExceeded" class="col-12" style="margin-bottom: 10px;">
        <span style="color: red; white-space: pre-line; font-size: 80%;">{{ taxAdjustmentThresholdMessage }}</span><br />
      </div>
      <div *ngIf="invoice?.AdminInfo != ''" class="col-12">
        <b style="color: red;">{{invoice?.AdminInfo}}</b><br />
      </div>
      <div *ngIf="invoice?.UserSettings?.AdminInfo != ''" class="col-12">
        <b style="color: red;">{{invoice?.UserSettings?.AdminInfo}}</b><br />
      </div>

      <!--Invoice info-->
      <div class="col-sm-12 col-md-6">
        <div class="card-stack">
          <mat-card>
          <mat-card-title>
            Fakturainfo
            <span *ngIf="invoice.SubInvoice" class="person" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Detta är en underfaktura"><mat-icon>person</mat-icon></span>
            <span *ngIf="invoice.ParentInvoice" class="person" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Detta är en moderfaktura"><mat-icon>groups</mat-icon></span>
          </mat-card-title>

          <div class="row card-field-row">
            <mat-form-field class="col-6">
              <mat-label>Förnamn</mat-label>
              <input type="text" [(ngModel)]="invoice.UserSettings.FirstName" matInput disabled />
            </mat-form-field>
            <mat-form-field class="col-6">
              <mat-label>Efternamn</mat-label>
              <input type="text" [(ngModel)]="invoice.UserSettings.LastName" matInput disabled />
            </mat-form-field>
            <mat-form-field class="col-6">
              <mat-label>Anställningsnummer</mat-label>
              <input type="text" [(ngModel)]="invoice.UserSettings.EmploymentNumber" matInput disabled />
            </mat-form-field>
            <mat-form-field class="col-6">
              <mat-label>Medlemsnummer</mat-label>
              <input type="text" [(ngModel)]="invoice.UserSettings.MemberNumber" matInput disabled />
            </mat-form-field>

            <mat-form-field class="col-6">
              <mat-label>Fakturanummer</mat-label>
              <input type="text" [(ngModel)]="invoice.InvoiceNumber" matInput disabled />
            </mat-form-field>

            <mat-form-field class="col-6">
              <mat-label>Faktura-id</mat-label>
              <input type="text" [(ngModel)]="invoice.Id" matInput disabled />
            </mat-form-field>
          </div>

          <mat-form-field class="col-12">
            <mat-label>OCR</mat-label>
            <input type="text" [(ngModel)]="invoice.Ocr" matInput disabled />
          </mat-form-field>

          <mat-form-field class="col-5">
            <mat-label>Inbetalningsdatum</mat-label>
            <input matInput [matDatepicker]="pickerInPayment" [(ngModel)]="invoice.PaymentDate" (dateChange)="invoice.PaymentDate = toFormattedDate($event.value)">
            <mat-datepicker-toggle matSuffix [for]="pickerInPayment"></mat-datepicker-toggle>
            <mat-datepicker #pickerInPayment></mat-datepicker>
          </mat-form-field>

          <!-- PaidTotal is pre-set to the total invoice amount inc vat, which is set when invoice is sent -->
          <mat-form-field class="col-5">
            <mat-label>Totalt inbetalt från kund</mat-label>
            <input type="number" maxlength="10" [ngModel]="invoice.PaidTotal" (ngModelChange)="invoice.PaidTotal=$event; _calculateAllAmounts(); updateExchangeRatePaid();" matInput />
          </mat-form-field>

          <span class="col-2">
            SEK
          </span>
          <mat-form-field class="col-10">
            <mat-label>Totalt fakturerat inkl. moms</mat-label>
            <input type="number" [ngModel]="invoice.TotalInvoiceAmountIncVat" (ngModelChange)="invoice.TotalInvoiceAmountIncVat=$event" name="TotalInvoiceAmountIncVat" matInput disabled />
          </mat-form-field>
          <span class="col-2">
            {{invoice.Currency.Name}}
          </span>
          <mat-form-field class="col-10">
            <mat-label>Totalt fakturerad moms</mat-label>
            <input type="number" [ngModel]="invoice.TotalVatAmount" matInput disabled />
          </mat-form-field>
          <span class="col-2">
            {{invoice.Currency.Name}}
          </span>

          <mat-form-field class="col-10">
            <mat-label>Fakturaavgift</mat-label>
            <input type="number" [ngModel]="InvoiceFeeReceiver" matInput disabled />
            <mat-hint *ngIf="invoice.InvoiceFeeDiscount" style="color:green;">
              {{invoice.InvoiceFeeDiscount.Code}} {{invoice.InvoiceFeeDiscount.Category == 0 ? invoice.InvoiceFeeDiscount.DiscountPercentage + '% rabatt' : invoice.InvoiceFeeDiscount.FixedDiscountAmount + ' kr rabatt'}}
            </mat-hint>
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>

          <div>
            <mat-form-field class="col-10">
              <mat-label>Totalt fakturerat exkl. moms</mat-label>
              <input type="number" [ngModel]="invoice.TotalInvoiceAmount" matInput disabled />
            </mat-form-field>
            <span class="col-2">
              {{invoice.Currency.Name}}
            </span>
          </div>
        </mat-card>
        <mat-card class="grey padding30">
          <mat-checkbox matInput [ngModel]="InvoiceFeePaidByCustomer" (change)="changeValue($event)">Kunden har betalat fakturaavgiften</mat-checkbox>
        </mat-card>
        <mat-card>
          <mat-form-field class="col-12 no-subscript" style="margin: 15px 0;">
            <mat-label>Fritext / kommentar</mat-label>
            <input type="text" [(ngModel)]="invoice.FeeDescription" matInput />
          </mat-form-field>
        </mat-card>
        </div>
      </div>

      <!--Fees added to invoice-->
      <div class="col-sm-12 col-md-6">
        <div class="card-stack">
          <mat-card>
          <mat-card-title>Avgifter (dras från fakturerat belopp)</mat-card-title>

          <mat-form-field class="col-10">
            <mat-label>Fa.avgift medlem</mat-label>
            <mat-icon *ngIf="!invoice.InvoiceFeeUnlocked && !invoice.FeePaidByReciever" (click)="invoice.InvoiceFeeUnlocked = !invoice.InvoiceFeeUnlocked" after matSuffix style="cursor: pointer;">lock</mat-icon>
            <mat-icon *ngIf="invoice.InvoiceFeeUnlocked  && !invoice.FeePaidByReciever" (click)="invoice.InvoiceFeeUnlocked = !invoice.InvoiceFeeUnlocked" after color="accent" matSuffix style="cursor: pointer;">lock_open</mat-icon>
            <input type="number" [disabled]="!invoice.InvoiceFeeUnlocked" [ngModel]="InvoiceFeeMember" (change)="_calculateAllAmounts()" (ngModelChange)="invoice.InvoiceFee=$event; InvoiceFeeMember=$event;" matInput />
            <mat-hint *ngIf="invoice.InvoiceFeeDiscount" style="color:green;">
              {{invoice.InvoiceFeeDiscount.Code}} {{invoice.InvoiceFeeDiscount.Category == 0 ? invoice.InvoiceFeeDiscount.DiscountPercentage + '% rabatt' : invoice.InvoiceFeeDiscount.FixedDiscountAmount + ' kr rabatt'}}
            </mat-hint>
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>

          <mat-form-field class="col-10">
            <mat-label>SAMpoolen-avgift</mat-label>
            <mat-icon *ngIf="!invoice.ServiceFeeUnlocked" (click)="invoice.ServiceFeeUnlocked = !invoice.ServiceFeeUnlocked" after matSuffix style="cursor: pointer;">lock</mat-icon>
            <mat-icon *ngIf="invoice.ServiceFeeUnlocked" (click)="invoice.ServiceFeeUnlocked = !invoice.ServiceFeeUnlocked" after color="accent" matSuffix style="cursor: pointer;">lock_open</mat-icon>
            <input type="number" [disabled]="!invoice.ServiceFeeUnlocked" [ngModel]="invoice.ServiceFee" (ngModelChange)="invoice.ServiceFee=$event" matInput (change)="_calculateAllAmounts()" />
            <mat-hint *ngIf="invoice.ServiceFeeDiscount" style="color:green;">
              {{invoice.ServiceFeeDiscount.Code}} {{invoice.ServiceFeeDiscount.Category == 0 ? invoice.ServiceFeeDiscount.DiscountPercentage + '% rabatt' : invoice.ServiceFeeDiscount.FixedDiscountAmount + ' kr rabatt'}}
            </mat-hint>
          </mat-form-field>

          <span class="col-2">
            SEK
          </span>

          <div class="col-10" style="margin: -15px 0 15px 0; font-size: 80%;">
            {{ServiceFeeInfo}}

          </div>
          <mat-form-field class="col-10">
            <mat-label>Bankavgift</mat-label>
            <mat-icon *ngIf="!invoice.ExchangeFeeUnlocked" (click)="invoice.ExchangeFeeUnlocked = !invoice.ExchangeFeeUnlocked" after matSuffix style="cursor: pointer;">lock</mat-icon>
            <mat-icon *ngIf="invoice.ExchangeFeeUnlocked" (click)="invoice.ExchangeFeeUnlocked = !invoice.ExchangeFeeUnlocked" after color="accent" matSuffix style="cursor: pointer;">lock_open</mat-icon>
            <input type="number" [disabled]="!invoice.ExchangeFeeUnlocked" [ngModel]="invoice.ExchangeFee" (ngModelChange)="invoice.ExchangeFee=$event" matInput (change)="_calculateAllAmounts()" />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
          <mat-form-field class="col-10">
            <mat-label>Påminnelseavgift</mat-label>
            <input type="number" [ngModel]="invoice.ReminderFee" (ngModelChange)="invoice.ReminderFee=$event" matInput (change)="_calculateAllAmounts()" />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
          <mat-form-field class="col-10">
            <mat-label>Inkassoavgift</mat-label>
            <input type="number" [ngModel]="invoice.InkassoFee" (ngModelChange)="invoice.InkassoFee=$event" matInput (change)="_calculateAllAmounts()" />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
          <mat-form-field class="col-10">
            <mat-label>Avgift Kronofogden</mat-label>
            <input type="number" [ngModel]="invoice.KronofogdenFee" (ngModelChange)="invoice.KronofogdenFee=$event" matInput (change)="_calculateAllAmounts()" />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
          <mat-form-field class="col-10">
            <mat-label>Manuell avgift</mat-label>
            <input type="number" [ngModel]="invoice.CustomFee" (ngModelChange)="invoice.CustomFee=$event" matInput (change)="_calculateAllAmounts()" />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
          <mat-form-field class="col-10">
            <mat-label>Manuell rabatt eller gåva</mat-label>
            <input type="number" [ngModel]="invoice.ManualDiscount" (ngModelChange)="invoice.ManualDiscount = $event; _calculateAllAmounts()" matInput />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
        </mat-card>
        <mat-card style="padding-top: 15px;">
          <mat-form-field class="col-10">
            <mat-label>Summa avgifter (inkl kunds ev fakturaavgift)</mat-label>
            <input type="number" [ngModel]="invoice.FeesTotalAmount" matInput disabled />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
          <mat-form-field class="col-10">
            <mat-label>Manuell rabatt</mat-label>
            <input type="number" [ngModel]="invoice.ManualDiscount" matInput disabled />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
          <div>
            <mat-form-field class="col-10">
              <mat-label>Delsumma (lönegrundande belopp + nettoersättningar)</mat-label>
              <input type="number" [value]="PartialTotalAmount" [(ngModel)]="PartialTotalAmount" matInput disabled />
            </mat-form-field>
            <span class="col-2">
              SEK
            </span>
          </div>
        </mat-card>
        </div>
      </div>
      <!-- If a payment date is set, a transaction log is created, otherwise it is just saved -->
      <div class="col-lg-12 col-sm-12" style="margin-top: 10px; padding-right: 25px; float: left;">
        <button mat-flat-button color="accent" (click)="save(invoice, false, false)" [disabled]="isLoading || !!pensionValidationMessage" style="float:right; display: block;">Spara endast inbetalning <span class="save-button-info" matTooltipClass="invoice-summary-save-tooltip" matTooltipPosition="below" aria-label="Information om sparandet" matTooltip="Sparar underlaget utan att lägga till/ändra utbetalningsdatum.&#10;&#10;Utbetalt: Befintliga utbetalningsloggar behålls.&#10;&#10;Ej utbetalt: En ny preliminär utbetalningslogg skapas och tidigare utbetalningsloggar inaktiveras." style="display: inline-flex; align-items: center; margin-left: 6px;"><mat-icon class="infoicon" style="position: static; width: 16px; height: 16px; font-size: 16px; line-height: 16px;">info</mat-icon></span></button>
        <a href="#/transactions" class="link">Gå till Ekonomi</a>
      </div>
      <div *ngIf="showPaidOutSubtotalWarning" class="col-6 ml-auto" role="alert" style="margin-top: 12px; color: red;">
        Utbetalning har redan gjorts. Ändring av dessa belopp påverkar delsumman som den redan gjorda utbetalningen beräknades från. Inga nya utbetalningsloggar skapas när du sparar här.
      </div>
    </div>
    <div *ngIf="isViewReady && payoutChecksComplete && !calculationError && !isLoading && invoice && !invoice.ParentInvoice" class="row align-items-start tight-columns card-gap-row" style="background-color: #f3f3f3; margin-top: 20px; padding: 20px 10px;">
      <div class="col-12">
        <h2>Beräkning av utbetalning av lön (inkl nettoersättningar)</h2>
      </div>
      <!--Deductions-->
      <div class="col-sm-12 col-md-6">
        <mat-card>
          <mat-card-title>Nettoersättningar</mat-card-title>
          <mat-form-field class="col-10">
            <mat-label>Privata avdrag</mat-label>
            <input type="number" [(ngModel)]="deductionsTotalAmountOriginal" matInput disabled />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
          <mat-form-field class="col-10">
            <mat-label>Traktamenten</mat-label>
            <input type="number" [(ngModel)]="allowancesTotalAmount" matInput disabled />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
          <mat-form-field class="col-10">
            <mat-label>Milersättning</mat-label>
            <input type="number" [(ngModel)]="milageTotalAmount" matInput disabled />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
          <mat-form-field class="col-10">
            <mat-label>Summa nettoersättningar</mat-label>
            <input type="number" [value]="expensesTotalAmountOriginalRounded" matInput disabled />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
          <mat-form-field class="col-10">
            <mat-label>Varav friskvårdsavdrag</mat-label>
            <input type="number" [(ngModel)]="healthCareTotalAmountThisInvoiceOriginal" matInput disabled />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>

          <div class="col-10 infotext" style="margin-bottom: 10px;">
            <span *ngIf="healthCareAmountExceedesLimit && !isInvoiceAlreadyPaidOut()" style="color: red;">Avdragen överstiger 5000 SEK. </span>
            <span *ngIf="healthCareTotalAmountThisInvoiceOriginal > 0">{{healthCareDeductionsMessage}}</span>
          </div>

          <mat-form-field class="col-10">
            <mat-label>Tjänstepension inkl skatt</mat-label>
            <input type="number" [(ngModel)]="PensionSavingsInclTax" matInput disabled />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
          <div>
            <mat-form-field class="col-10">
              <mat-label>Lönegrundande belopp (delsumma - nettoersättningar - tjänstepension inkl skatt)</mat-label>
              <input type="number" [(value)]="PartialAmountExclNetExpenses" matInput disabled />
            </mat-form-field>
            <span class="col-2">
              SEK
            </span>
          </div>
        </mat-card>
      </div>
      <!--Taxes-->
      <div class="col-sm-12 col-md-6">
        <mat-card>
          <mat-card-title>Skatter</mat-card-title>
          <mat-form-field class="col-10">
            <mat-label>Lönegrundande belopp (delsumma - nettoersättningar)</mat-label>
            <input type="number" [(value)]="PartialAmountExclNetExpenses" matInput disabled />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
          <mat-form-field class="col-5" *ngIf="!employerTaxBreakdown?.hasTempYouthCalculation">
            <mat-label>Arbetsgivaravgift</mat-label>
            <input type="number" [value]="invoice.ArbetsgivarAvgift" matInput disabled />
          </mat-form-field>
          <span class="col-2" *ngIf="!employerTaxBreakdown?.hasTempYouthCalculation">
            SEK
          </span>
          <mat-form-field class="col-5" *ngIf="!employerTaxBreakdown?.hasTempYouthCalculation">
            <mat-label>Arb.g.avg</mat-label>
            <mat-select required disabled [(ngModel)]="invoice.EmployerTaxType.Id" name="employertax" id="employertax" (ngModelChange)="invoice.EmployerTaxType.Id = $event; employerTaxUpdated($event);">
              <mat-option *ngFor="let item of employerTaxes" [value]="item.Id">
                {{ item.Tax * 100 | number: '1.0-2' }} % ({{item.Name}})
              </mat-option>
            </mat-select>
          </mat-form-field>
          <span class="col-2" *ngIf="!employerTaxBreakdown?.hasTempYouthCalculation">
          </span>

          <div class="col-12 tax-breakdown" *ngIf="employerTaxBreakdown?.hasTempYouthCalculation">
            <div class="tax-breakdown-title">TempYouth m&aring;nadsgr&auml;ns</div>
            <div class="tax-breakdown-info" *ngIf="!employerTaxBreakdown.isHistorical">
              TempYouth g&auml;ller upp till {{ employerTaxBreakdown.monthlyLimit | number: '1.0-0' }} SEK bruttol&ouml;n per m&aring;nad.
              Tidigare utbetald bruttol&ouml;n denna m&aring;nad: {{ employerTaxBreakdown.paidGrossSalaryInPayoutMonth | number: '1.0-0' }} SEK.
              Kvar f&ouml;r TempYouth: {{ employerTaxBreakdown.remainingTempYouthGrossSalary | number: '1.0-0' }} SEK.
            </div>
            <div class="tax-breakdown-info" *ngIf="employerTaxBreakdown.isHistorical">
              Ber&auml;kningen nedan &auml;r den som sparades vid utbetalningstillf&auml;llet.
            </div>
            <div class="tax-breakdown-header">
              <span>Bruttol&ouml;n</span>
              <span>Arbetsgivaravgift</span>
              <span>Avgift</span>
            </div>
            <div class="tax-breakdown-row" *ngIf="employerTaxBreakdown.tempYouthGrossSalary > 0">
              <div>
                <span class="tax-breakdown-label">Bruttol&ouml;n 1, t.o.m. 25 000</span>
                <strong>{{ employerTaxBreakdown.tempYouthGrossSalary | number: '1.0-0' }} SEK</strong>
              </div>
              <div>
                <span class="tax-breakdown-label">TempYouth</span>
                <strong>{{ employerTaxBreakdown.tempYouthEmployerTaxAmount | number: '1.0-0' }} SEK</strong>
              </div>
              <div>
                <span class="tax-breakdown-label">Procentsats</span>
                <strong>{{ employerTaxBreakdown.tempYouthTaxRate * 100 | number: '1.0-2' }} %</strong>
              </div>
            </div>
            <div class="tax-breakdown-row" *ngIf="employerTaxBreakdown.normalGrossSalary > 0">
              <div>
                <span class="tax-breakdown-label" *ngIf="employerTaxBreakdown.remainingTempYouthGrossSalary > 0">Bruttol&ouml;n 2, &ouml;ver 25 000</span>
                <span class="tax-breakdown-label" *ngIf="employerTaxBreakdown.remainingTempYouthGrossSalary <= 0">Bruttol&ouml;n med ordinarie avgift</span>
                <strong>{{ employerTaxBreakdown.normalGrossSalary | number: '1.0-0' }} SEK</strong>
              </div>
              <div>
                <span class="tax-breakdown-label">Normal</span>
                <strong>{{ employerTaxBreakdown.normalEmployerTaxAmount | number: '1.0-0' }} SEK</strong>
              </div>
              <div>
                <span class="tax-breakdown-label">Procentsats</span>
                <strong>{{ employerTaxBreakdown.normalTaxRate * 100 | number: '1.0-2' }} %</strong>
              </div>
            </div>
            <div class="tax-breakdown-actions" *ngIf="!employerTaxBreakdown.isHistorical">
              <button type="button" mat-flat-button color="accent" (click)="recalculateTempYouth()" [disabled]="isLoading">
                Uppdatera TempYouth-beräkning
              </button>
            </div>
          </div>

          <mat-form-field class="col-10">
            <mat-label>Bruttolön (lönegrundande belopp - arb.g.avgift)</mat-label>
            <input type="number" [ngModel]="invoice.BruttoLon" matInput disabled />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>

          <mat-form-field class="col-5">
            <mat-label>Kommunalskatt</mat-label>
            <input type="number" [(ngModel)]="PayoutMunicipalityTax" matInput disabled />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>

          <span class="col-2">
            {{ municipalityTaxFactor * 100  | number: '1.2-2'}} %
          </span>

          <!--<span class="col-2" *ngIf="invoice?.UserSettings?.TaxAdjustments == null || invoice?.UserSettings?.TaxAdjustments.length == 0">
            {{ invoice?.UserSettings?.Municipality?.Tax * 100  | number: '1.2-2'}} %
          </span>

          <span class="col-2" *ngIf="invoice?.UserSettings?.TaxAdjustments != null && invoice?.UserSettings?.TaxAdjustments.length > 0">
            {{ invoice?.UserSettings?.TaxAdjustments[0]?.TemporaryTax * 100  | number: '1.2-2'}} %
          </span>-->
          <div class="highlight">
            <mat-form-field class="col-10">
              <mat-label>Nettolön (bruttolön - kommunalskatt)</mat-label>
              <input type="number" [(ngModel)]="invoice.NettoLon" matInput disabled />
            </mat-form-field>
            <span class="col-2">
              SEK
            </span>

            <div *ngIf="invoice?.UserSettings?.HasCoordinationNumber" style="color: red; font-size: 80%; padding: 0 0 0 15px; font-style: italic;">
              Medlemmen har samordningsnummer. Angivet födelseår: {{ invoice?.UserSettings?.BirthYear }}
            </div>
          </div>
        </mat-card>

      </div>

      <!-- Wage garnishment  -->
      <div *ngIf="userHasWageGarnishment" class="col-sm-12 col-md-6">
        <mat-card>
          <mat-card-title>Löneutmätning</mat-card-title>
          <mat-form-field class="col-9">
            <mat-label>Reserverat belopp (att behålla)</mat-label>
            <input type="number" [(ngModel)]="activeWageGarnishment.ReservedAmount" matInput disabled />
          </mat-form-field>
          <span class="col-3">
            SEK/mån
          </span>
          <mat-form-field class="col-9">
            <mat-label>Utmätt belopp (att betala)</mat-label>
            <input type="number" [(ngModel)]="activeWageGarnishment.AttachmentAmount" matInput disabled />
          </mat-form-field>
          <span class="col-3">
            SEK/mån
          </span>
          <mat-form-field class="col-10">
            <mat-label>Total nettobetalning innevarande månad</mat-label>
            <input type="number" [(ngModel)]="netPaidThisMonth" matInput disabled />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
          <mat-form-field class="col-10">
            <mat-label>Totalt utmätt innevarande månad</mat-label>
            <input type="number" [(ngModel)]="userWageGarnishmentsCurrentMonth" matInput disabled />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
          <mat-form-field class="col-10">
            <mat-label>Möjligt att utmäta (nettolön + utmätbara nettoersättningar)</mat-label>
            <input type="number" [(ngModel)]="totalAssessableAmount" matInput disabled />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>
          <div class="highlight">
            <mat-form-field class="col-10">
              <mat-label>Utmätning denna faktura</mat-label>
              <input type="number" [(ngModel)]="invoice.wageGarnishmentAmount" matInput disabled />
            </mat-form-field>
            <span class="col-2">
              SEK
            </span>
          </div>
          <button mat-flat-button color="accent" (click)="recalculateGarnishment()" [disabled]="isLoading" style="float:right; margin: 15px;   display: block;">Räkna om utmätning</button>

        </mat-card>
      </div>
      <div *ngIf="userHasWageGarnishment" class="col-sm-12 col-md-6">
      </div>

      <!--Payment / net salary-->
      <div class="col-sm-12 col-md-6">

        <mat-card>
          <mat-card-title>Utbetalning</mat-card-title>

          <mat-form-field class="col-10">
            <mat-label>Nettolön</mat-label>
            <input type="number" [(ngModel)]="invoice.NettoLon" matInput disabled />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>

          <mat-form-field class="col-10">
            <mat-label>Summa nettoersättningar</mat-label>
            <input type="number" [value]="expensesTotalAmountRounded" matInput disabled />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>

          <mat-form-field class="col-10">
            <mat-label>Tjänstepension inkl skatt</mat-label>
            <input type="number" [(ngModel)]="PensionSavingsInclTax" matInput disabled />
          </mat-form-field>
          <span class="col-2">
            SEK
          </span>

          <mat-form-field *ngIf="userHasWageGarnishment" class="col-10">
            <mat-label>Löneutmätning denna faktura</mat-label>
            <input type="number" [(ngModel)]="invoice.wageGarnishmentAmount" matInput disabled />
          </mat-form-field>
          <span *ngIf="userHasWageGarnishment" class="col-2">
            SEK
          </span>


          <div>
            <mat-form-field class="col-10">
              <mat-label>Beräkning utbetalning</mat-label>
              <input type="number" [(ngModel)]="invoice.PayOutTotal" matInput disabled />
            </mat-form-field>
            <span class="col-2">
              SEK
            </span>
            <div class="infotext" style="color: red;" *ngIf="invoice.ExpensesTotalAmount > PartialTotalAmount || netExpensesAdjustmentAmount > 0">
              <i>
                Nettoersättningarna överstiger delbeloppet
                <span *ngIf="netExpensesAdjustmentAmount > 0">. Justerat -{{ netExpensesAdjustmentAmount | number:'1.0-2' }} SEK</span>
              </i>
            </div>
          </div>
          <mat-form-field class="col-10" *ngIf="invoice.ExchangeRateInvoiceSent != 0">
            <mat-label>Valutakurs vid utbetalning</mat-label>
            <input type="number" [(ngModel)]="invoice.ExchangeRateInvoicePaid" (ngModelChange)="invoice.invoice.ExchangeRateInvoicePaid=$event;" matInput />
          </mat-form-field>
          <span class="col-2" *ngIf="invoice.ExchangeRateInvoiceSent != 0">
            SEK
          </span>

        </mat-card>

      </div>

      <!--Payout info / net salary -->
      <div class="col-sm-12 col-md-6">
        <mat-card>
          <mat-card-title>Betalinformation</mat-card-title>

          <div class="row col-lg-12" style="margin: 0 0 20px -15px">
            <!--<div class="row col-lg-12"><div class="col-lg-6">Totalt att betala ut : </div><div class="col-lg-6"><b>{{ invoice.PayOutTotal }}</b></div></div>-->
            <!--<div class="row col-lg-12" ><div class="col-lg-6">Utmätning till Kfm: </div><div class="col-lg-6">{{ attachmentPaymentToKronofogdenAmount }}</div></div>-->
            <div class="row col-lg-12"><br /><br /><div class="col-lg-6">Personnr: </div><div class="col-lg-6"><input class="tabbable-static-value" [value]="invoice?.UserSettings?.PersonalNumber || ''" readonly /></div></div>
            <div class="row col-lg-12" *ngIf="userHasWageGarnishment"><div class="col-lg-6">Löneutmätning KFM: </div><div class="col-lg-6"><input class="tabbable-static-value bold-value" [value]="invoice.wageGarnishmentAmount" readonly /></div></div>
            <div class="row col-lg-12" *ngIf="userHasWageGarnishment"><div class="col-lg-6">BG KFM: </div><div class="col-lg-6"><input class="tabbable-static-value" value="756-2036" readonly /></div></div>
            <div class="row col-lg-12" *ngIf="userHasWageGarnishment"><div class="col-lg-6">Text avsändarkonto: </div><div class="col-lg-6"><input class="tabbable-static-value" [value]="textSender" readonly /></div></div>
            <div class="row col-lg-12" style="margin-bottom: 20px;" *ngIf="userHasWageGarnishment"><div class="col-lg-6">Meddelande till KFM: </div><div class="col-lg-6"><input class="tabbable-static-value" [value]="messageToKFM" readonly /></div></div>

            <div class="row col-lg-12" *ngIf="invoice.PensionSavingsAmount > 0"><div class="col-lg-6">Totalt till tjänstepension: </div><div class="col-lg-6"><input class="tabbable-static-value" [value]="(displayedPensionSavingsAmount + pensionSavingsTaxAmount) + ' (' + displayedPensionSavingsAmount + '+' + pensionSavingsTaxAmount + ')'" readonly /></div></div>
            <div class="row col-lg-12" *ngIf="invoice.PensionSavingsAmount > 0"><div class="col-lg-6">Tjänstepensionsföretag: </div><div class="col-lg-6"><input class="tabbable-static-value" [value]="invoice?.UserSettings?.PensionSavingsSettings?.PensionSavingsCompany?.Name || ''" readonly /></div></div>

            <div *ngIf="!hasPreviousPensionSaving && invoice.PensionSavingsAmount > 0" style="width: 100%; border: 1px solid grey;">
              <div class="row col-lg-12"><div class="col-lg-6">Epost: </div><div class="col-lg-6"><input class="tabbable-static-value" [value]="invoice?.UserSettings?.Email || ''" readonly /></div></div>
              <div class="row col-lg-12"><div class="col-lg-6">Telefon: </div><div class="col-lg-6"><input class="tabbable-static-value" [value]="invoice?.UserSettings?.Phone || ''" readonly /></div></div>
            </div>
            <div *ngIf="hasPreviousPensionSaving && invoice.PensionSavingsAmount > 0" class="row col-lg-12" style="width: 100%; height: 20px">
              <div class="col-lg-12" style="font-style: italic;">{{pensionSavingsMessage}}</div>
            </div>

            <br /><br />
            <div class="row col-lg-12">
              <div class="col-lg-6">Bank: </div><div class="col-lg-6"><input class="tabbable-static-value" [value]="invoice?.UserSettings?.BankName || ''" readonly /></div>
            </div>
            <div *ngIf="invoice?.UserSettings?.Bank.Id != 2" class="row col-lg-12">
              <div class="col-lg-6"></div>
              <div class="col-lg-6" *ngIf="invoice?.UserSettings?.ClearingNumber != '3300'"><input class="tabbable-static-value" [value]="(invoice?.UserSettings?.ClearingNumber || '') + ' ' + (invoice?.UserSettings?.AccountNumber || '')" readonly /></div>
              <div class="col-lg-6" *ngIf="invoice?.UserSettings?.ClearingNumber == '3300'"><input class="tabbable-static-value" [value]="invoice?.UserSettings?.AccountNumber || ''" readonly /></div>
            </div>
            <div *ngIf="invoice?.UserSettings?.Bank.Id == 2" class="row col-lg-12">
              <div class="col-lg-6">BIC + IBAN: </div>
              <div class="col-lg-6"><input class="tabbable-static-value" [value]="(invoice?.UserSettings?.Bic || '') + ' ' + (invoice?.UserSettings?.Iban || '')" readonly /></div>
            </div>

            <div class="row col-lg-12">
              <div class="col-lg-6">Namn: </div><div class="col-lg-6"><input class="tabbable-static-value" [value]="displayedPayoutName" readonly /></div>
            </div>
                        
            <div class="row col-lg-12"><div class="col-lg-6">Totalt att betala ut : </div><div class="col-lg-6"><input class="tabbable-static-value bold-value" [value]="invoice.PayOutTotal" readonly /></div></div>

            <p class="col-12 payout-difference-warning" role="alert" *ngIf="payoutDifference as mismatch">
              {{ mismatch.beforeSave ? 'Den skapade utbetalningen skiljer sig från beräkningen som visades före sparandet, se nedan.' : 'Denna beräkning skiljer sig från ' + (mismatch.preliminary ? 'den preliminära utbetalningen' : 'den utförda utbetalningen') + ', se nedan.' }}
            </p>
            <mat-form-field class="col-12" style="margin-top: 20px;">
              <mat-label>Datum för utbetalning</mat-label>
              <input matInput [matDatepicker]="pickerPayment" [(ngModel)]="invoice.PayoutDate" (dateChange)="onPayoutDateChanged($event.value)">
              <mat-datepicker-toggle matSuffix [for]="pickerPayment"></mat-datepicker-toggle>
              <mat-datepicker #pickerPayment></mat-datepicker>
            </mat-form-field>
            <div class="row col-lg-12"><div class="col-lg-6">Text mottagarkonto: </div><div class="col-lg-6"><input class="tabbable-static-value" [value]="'sam' + invoice?.InvoiceNumber" readonly /></div></div>
            <div class="row col-lg-12"><div class="col-lg-6">Text avsändarkonto: </div><div class="col-lg-6"><input class="tabbable-static-value" [value]="textSender" readonly /></div></div>
          </div>

          <div class="row col-lg-12"
               style="margin-bottom: 20px;"
               [ngStyle]="{ 'color': isInvoiceAlreadyPaidOut() ? 'lightgrey' : payoutDayInfoColor }">
            <div class="row col-lg-12">
              <div class="col-lg-6">Utbetalningsval:</div>
              <div class="col-lg-6">
                <textarea class="tabbable-static-value" [value]="payoutDayInfo + (payoutDaySelectedInfo && payoutDayWasAdjusted ? '\n(Valt: ' + payoutDaySelectedInfo + ')' : '')" readonly rows="2"></textarea>
              </div>
            </div>
          </div>


          

          <div [style.color]="(taxChanged) ? 'red' : 'black'" style="font-size: 80%; padding-left: 15px; font-style: italic;">
            <div [innerHTML]="lastPayoutMessage"></div>
          </div>
          <div *ngIf="invoice.SubInvoice && invoice.ExpressPayOut && !invoice.ApprovedForExpress" style="color: red; font-size: 80%; padding-left: 15px; font-style: italic;">
            Expressutbetalning är vald, men moderfakturan är ej bekräftad
          </div>
          <div *ngIf="!invoice.SubInvoice && !invoice.ParentInvoice && invoice.ExpressPayOut && !invoice.ApprovedForExpress" style="color: red; font-size: 80%; padding: 0 0 15px 15px; font-style: italic;">
            Expressutbetalning är vald, men fakturan är ej bekräftad
          </div>

        </mat-card>
      </div>
      <!-- /Payout info / net salary -->
      <div *ngIf="invoice.PensionSavingsAmount > 0" class="col-12 col-md-6 offset-md-6">
        <p>
          Pensionsavsättning exklusive skatt: {{invoice.PensionSavingsAmount | number:'1.0-0'}} kr.
          <ng-container *ngIf="pensionShareOfGrossSalaryPercent !== null; else pensionShareUnavailable">
            Andel av slutgiltig bruttolön: <strong>{{pensionShareOfGrossSalaryPercent | number:'1.2-2'}} %</strong>
            (bruttolön {{invoice.BruttoLon | number:'1.0-0'}} kr).
          </ng-container>
          <ng-template #pensionShareUnavailable>Andelen kan inte beräknas eftersom bruttolönen är noll eller negativ.</ng-template>
          Högsta tillåtna andel är 10 % exklusive pensionsskatt.
        </p>
      </div>
      <!-- Save -->
      <div class="row col-lg-12 col-sm-12" style="margin-right: 0; padding: 0 10px 0 33px;">
        <div class="col-12" style="margin-top: 10px;">
          <div class="col-lg-12 col-sm-12 invoice-save-actions" style="justify-content: flex-end; flex-wrap: wrap;">
            <p *ngIf="isInvoicePayoutBlocked()" class="mat-error" style="flex-basis: 100%;">En krediterad eller kvittad faktura kan inte betalas ut. Töm utbetalningsdatumet för att spara hela underlaget utan utbetalning.</p>
            <button color="accent" mat-stroked-button (click)="save(invoice, false, true)" [disabled]="(isInvoicePayoutBlocked() && !!invoice.PayoutDate) || isLoading || !saveValid" style="flex: 0 0 auto; white-space: nowrap;">Spara utan att skicka epost <span class="save-button-info" matTooltipClass="invoice-summary-save-tooltip" matTooltipPosition="below" area-label="Hover to display info" matTooltip="Sparar hela underlaget och skapar alltid ny utbetalningslogg utan att skicka mail till medlem."><mat-icon class="infoicon">info</mat-icon></span></button>
            <button mat-flat-button color="accent" (click)="save(invoice, true, true)" [disabled]="(isInvoicePayoutBlocked() && !!invoice.PayoutDate) || isLoading || !saveValid" style="flex: 0 0 auto; white-space: nowrap;">Spara hela underlaget <span class="save-button-info" matTooltipClass="invoice-summary-save-tooltip" matTooltipPosition="below" area-label="Hover to display info" matTooltip="Sparar underlaget, skapar utbetalningslogg om datum är nytt eller ändrat. Skickar då mail till medlem om utbetalning."><mat-icon class="infoicon">info</mat-icon></span></button>
            <!--<a href="#/transactions" class="link">Gå till Ekonomi</a>-->
          </div>
          <div class="col-lg-12 col-sm-12" style="margin-top: 10px; float: right; font-size: 80%; color: red;">
            {{saveMessage}}
          </div>
        </div>
      </div>
      <!-- / Save -->
      <div class="col-12" *ngIf="payoutDifference as mismatch">
        <section class="payout-difference-details" aria-labelledby="payout-difference-heading">
          <p id="payout-difference-heading"><strong>{{ mismatch.beforeSave ? 'Beräkningen före sparandet skiljer sig från den skapade utbetalningsloggen' : 'Beräkningen skiljer sig från ' + (mismatch.preliminary ? 'den preliminära loggen' : 'utbetalningsloggen') }} ({{ mismatch.logId }}).</strong></p>
          <div class="payout-difference-scroll">
            <table class="payout-difference-table" aria-labelledby="payout-difference-heading">
              <thead>
                <tr><th scope="col">Belopp</th><th scope="col">{{ mismatch.beforeSave ? 'Vyn före sparandet' : 'Vyn' }}</th><th scope="col">Loggen</th></tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">Totalt att betala ut</th>
                  <td>{{ mismatch.current | number:'1.2-2' }} SEK</td>
                  <td>{{ mismatch.saved | number:'1.2-2' }} SEK</td>
                </tr>
                <tr>
                  <th scope="row">Differens (vyn minus loggen)</th>
                  <td colspan="2">{{ mismatch.difference | number:'1.2-2' }} SEK</td>
                </tr>
                <tr *ngFor="let item of mismatch.items">
                  <th scope="row">{{ item.label }}</th>
                  <td>{{ item.current | number:'1.2-2' }} SEK</td>
                  <td>{{ item.saved | number:'1.2-2' }} SEK</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p *ngIf="!mismatch.items.length">Skillnaden kan inte förklaras av de jämförbara delbeloppen. Kontrollera beräkningsunderlaget.</p>
        </section>
      </div>
      <div *ngIf="showPaidOutSubtotalWarning" class="col-6 ml-auto" role="alert" style="margin-top: 12px; color: red;">
        Utbetalning har redan gjorts. Ändring av dessa belopp påverkar delsumman som den tidigare utbetalningen beräknades från. När du sparar här räknas utbetalningen om. För att skapa en ny utbetalningslogg med oförändrat utbetalningsdatum, välj Spara utan att skicka epost.
      </div>

    </div>

    <h3 *ngIf="isViewReady && !isLoading && transLogsRetrieved && payoutTransactionLog?.PayoutDate">Info från logg {{ payoutTransactionLog?.PayoutDate | swedishDate:'yyyy-MM-dd' }}</h3>
    <table *ngIf="isViewReady && !isLoading && transLogsRetrieved && payoutTransactionLog?.PayoutDate" style="margin-top: 20px; width: 100%;">
      <thead>
        <tr>
          <th>Löneart</th>
          <th>Km / antal</th>
          <th>SEK/dag</th>
          <th>Arb.giv.avg.</th>
          <th>Bruttolön</th>
          <th>Ink.skatt</th>
          <th style="text-align: right;">Nettolön/belopp</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of tableRows">
          <td>{{ row.loneart }}</td>
          <td>{{ row.kmAntal }}</td>
          <td>{{ row.sekDag }}</td>
          <td>{{ row.arbGivAvg }}</td>
          <td>{{ row.bruttoLon }}</td>
          <td>{{ row.inkSkatt }}</td>
          <td style="text-align: right;">{{ row.nettoLonBelopp }}</td>
        </tr>
      </tbody>
    </table>

    <br />
    <br />

    <!--OLD TABLE-->
    <h3 *ngIf="isViewReady && !isLoading && !calculationError">Info från vyn</h3>

    <table *ngIf="isViewReady && !isLoading && !calculationError" [class.light-grey]="!saveValid || transLogsRetrieved" style="margin-top: 20px; width: 100%; margin-bottom: 150px;">
      <thead>
        <tr>
          <th>Löneart</th>
          <th>Km / antal</th>
          <th>SEK/dag</th>
          <th>Arb.giv.avg.</th>
          <th>Bruttolön</th>
          <th>Ink.skatt</th>
          <th style="text-align: right;">Nettolön/belopp</th>
        </tr>
      </thead>
      <tbody>
        <!--Invoice-level information-->
        <tr>
          <td>1101</td>
          <td></td>
          <td></td>
          <td>{{ invoice?.ArbetsgivarAvgift }}</td>
          <td>{{ invoice?.BruttoLon }}</td>
          <td>{{ PayoutMunicipalityTax }}</td>
          <td style="text-align: right;">{{ invoice?.NettoLon }}</td>
        </tr>
        <!-- Deductions -->
        <tr *ngFor="let deduction of approvedDeductions">
          <td>{{ deduction?.TravelExpense ? '1223' : deduction?.HealthCare ? '1228' : '1224' }}{{ deduction?.AddedToInvoice ? '1' : '' }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td style="text-align: right;">{{ deduction?.PayoutAdjustedAmount != null ? deduction?.PayoutAdjustedAmount : deduction?.Amount }}</td>
        </tr>
        <!-- Allowances -->
        <ng-container *ngIf="invoice?.Allowances">
          <ng-container *ngFor="let allowance of invoice.Allowances">
            <ng-container *ngIf="allowance?.ApprovedByAdmin === true">
            <tr *ngIf="allowance.Mileage > 0">
              <td>1232</td>
              <td>{{ allowance?.Mileage }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align: right;">{{ allowance?.Sum }}</td>
            </tr>
            <tr *ngIf="allowance.FullDays > 0">
              <td>{{ allowance?.AllowanceType.Id == 2 ? '1201' : '1204' }}</td>
              <td>{{ allowance?.FullDays }}</td>
              <td>{{ allowance?.AllowancePerDay }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align: right;">{{ allowance?.sumAllowanceFullDays }}</td>
            </tr>
            <tr *ngIf="allowance.HalfDays > 0">
              <td>{{ allowance?.AllowanceType.Id == 2 ? '1202' : '1204 (halv)' }}</td>
              <td>{{ allowance?.HalfDays }}</td>
              <td>{{ allowance?.AllowancePerDay / 2 }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align: right;">{{ allowance?.sumAllowanceHalfDays }}</td>
            </tr>
            <tr *ngIf="allowance.Brekafasts > 0">
              <td>{{ allowance?.AllowanceType.Id == 2 ? '1209' : '1215' }}</td>
              <td>{{ allowance?.Brekafasts }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align: right;">{{ allowance?.BrekafastsAmount }}</td>
            </tr>
            <tr *ngIf="(allowance.Lunches > 0 || allowance.Dinners > 0) && allowance.AllowanceType.Id == 2">
              <td>1210</td>
              <td>{{ allowance?.Lunches + allowance?.Dinners }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align: right;">{{ allowance?.LunchesAmount + allowance?.DinnersAmount }}</td>
            </tr>
            <tr *ngIf="allowance.Lunches > 0 && allowance.AllowanceType.Id == 3">
              <td>1216</td>
              <td>{{ allowance?.Lunches }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align: right;">{{ allowance?.LunchesAmount }}</td>
            </tr>
            <tr *ngIf="allowance.Dinners > 0 && allowance.AllowanceType.Id == 3">
              <td>1217</td>
              <td>{{ allowance?.Dinners }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td style="text-align: right;">{{ allowance?.DinnersAmount }}</td>
            </tr>
            </ng-container>
          </ng-container>
        </ng-container>
        <tr *ngIf="invoice.PensionSavingsAmount > 0">
          <td>{{invoice?.UserSettings?.PensionSavingsSettings?.PensionSavingsCompany?.Name}}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td style="text-align: right;">{{ displayedPensionSavingsAmount + '+' + pensionSavingsTaxAmount}}</td>
        </tr>
        <tr>
          <td>1313</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td style="text-align: right;">{{ invoice.PayOutTotal }}</td>
        </tr>
        <tr *ngIf="userHasWageGarnishment">
          <td>1311</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td style="text-align: right;">{{ invoice.wageGarnishmentAmount }}</td>
        </tr>
      </tbody>
    </table>

    <section *ngIf="isViewReady && invoice" aria-label="Så fungerar sparandet" style="margin-top: 24px; margin-bottom: 24px;">
      <h3>Så fungerar sparandet</h3>
      <p><strong>Spara endast inbetalning (övre knappen):</strong> Sparar ändringarna i underlaget utan att lägga till/ändra utbetalningsdatum. Om underlaget redan är utbetalt behålls utbetalningsloggarna. Annars skapas en ny preliminär utbetalningslogg och tidigare utbetalningsloggar inaktiveras.</p>
      <p><strong>Spara hela underlaget (nedre knappen):</strong> Sparar hela underlaget, inklusive inbetalningsuppgifter och utbetalningsunderlag. När ett nytt eller ändrat utbetalningsdatum sparas skapas en ny utbetalningslogg. Utbetalningsmejl skickas då om medlemmen har aktiverat sådana aviseringar.</p>
      <p><strong>Spara utan att skicka epost:</strong> Sparar hela underlaget och skapar en ny utbetalningslogg även om utbetalningsdatumet är oförändrat. Om utbetalningsdatum saknas skapas i stället en preliminär utbetalningslogg. Inget utbetalningsmejl skickas.</p>
      <p>Utan inbetalningsdatum sparas fortfarande hela underlaget, men ingen inbetalningslogg skapas. För vanliga fakturor skapas en inbetalningslogg när inbetalningsdatum anges eller ändras.</p>
    </section>

  </div>
</div>
